import { css } from 'styled-components';

export default css`
  .general {
    margin-bottom: 20px;
  }
`;
